<template>
  <div>
    <create-w-modal
        ref="mdl"
        @create="refresh"
        @edit="refresh"
        @opened="$refs.dmdl.close()"
    />
    <details-w-dialog
        ref="dmdl"
        @opened="$refs.mdl.close()"
        @delete="$refs.delm.open($event)"
        @edit="$refs.mdl.open($event, true)"
    />
    <white-bg style="position:relative; overflow: hidden">
      <transition name="fade">
        <div class="filter" v-if="coworking && coworking.length">
          <custom-checkbox
              v-for="({name, color, id, selected},i) in coworking"
              class="item"
              :color="color"
              :key="i+'cow'"
              @change="setSelectedCoworking($event, id)"
              :value="selected"
          >
            {{ name }}
          </custom-checkbox>
        </div>
      </transition>

      <div class="mini-calendar" v-if="mobile">
        <mini-calendar
            @addEvent="$refs.mdl.open()"
            @input="goto($event.toDate())"
            :value="getDate()"
        />
      </div>

      <div>
        <div class="calendar-control" v-if="!mobile">
          <div class="calendar-title">{{ api ? api.view.title.replace(/\s\d{4}\s.{2}/, '') : '' }}
            <span>{{ api ? api.view.title.match(/\s\d{4}\s.{2}/)[0] : '' }}</span></div>
          <div>
            <button class="control-btn" @click="prev()">&#x276E;</button>
            <button class="today-btn" @click="today()">Сегодня</button>
            <button class="control-btn" @click="next()">&#x276F;</button>
          </div>
        </div>
        <delete-dialog
            ref="delm"
            @confirm="deleteEvent"
            text="Вы действительно хотите удалить эту запись?"
            @showed="$refs.dmdl.close()"
        />
        <MCalendar
            @mobile="mobile = $event"
            ref="cld"
            @setApi="setApi"
            @select="$refs.mdl.open($event)"
            @eventClick="$refs.dmdl.open($event)"
        />
      </div>
    </white-bg>
  </div>
</template>

<script>
import WhiteBg from "@/components/ui/white-bg"
import CustomCheckbox from "@/components/ui/inputs/custom-checkbox"
import MCalendar from "@/pages/Cabinet/Master/CalendarApi/MCalenadar"
import DeleteDialog from "@/pages/Cabinet/Master/CalendarApi/deleteDialog"
import { mapMutations } from "vuex"
import CreateWModal from "@/pages/Cabinet/Master/CalendarApi/WorkingCalendar/createModal"
import DetailsWDialog from "@/pages/Cabinet/Master/CalendarApi/WorkingCalendar/detailsDialog"
import MiniCalendar from "@/pages/Cabinet/Master/CalendarApi/miniCalendar"
import moment from "moment"

export default {
  name: "WordkCalendar",
  components: {MiniCalendar, DetailsWDialog, CreateWModal, DeleteDialog, MCalendar, CustomCheckbox, WhiteBg},
  data: () => ({
    api: null,
    mobile: false,
    date: new Date(),
    coworking: null,
    records: [],
    period: {start: null, end: null}
  }),
  computed: {
    isMobile() {
      return document.documentElement.clientWidth < 1170
    }
  },
  methods: {
    ...mapMutations(['openModal', 'setModalData']),
    getSelectedCoworking() {
      return this.coworking.filter(val => val.selected).map(val => val.id)
    },
    setCoworking(events) {
      return this.coworking = this._.uniqBy(Object.assign([], events).map((val) => val.coworking), (val) => {
        if (val) return val.id
      }).filter((val) => val).map(val => {
        return val
      })
    },
    setSelectedCoworking(e, id, background = false) {
      this.$set(this, 'coworking', this.coworking.map(val => {
        if (id === val.id) val.selected = e
        return val
      }))
      this.$refs.cld.updateCalendar(this.records, this.getSelectedCoworking(), background)
    },
    loadRecords() {
      return this.$api.master.record.list({start: this.period.start, end: this.period.end}).then(({data}) => {
        this.setCoworking(this.records = data).forEach(val => this.setSelectedCoworking(true, val.id))
        this.loadRents()
      })
    },
    deleteEvent(id) {
      this.$refs.delm.close()
      this.$refs.dmdl.close()
      this.$api.master.record.destroy(id).then(() => this.refresh())
    },
    setApi(e) {
      this.api = e
    },
    prev() {
      this.api.prev()
    },
    today() {
      this.api.today()
    },
    next() {
      this.api.next()
    },
    goto(date) {
      this.api.gotoDate(date)
    },
    getDate() {
      return this.api.getDate()
    },
    getTitle() {
      if (this.api != null) return this.api.view.title
      else return ''
    },
    refresh() {
      this.loadRecords().finally(() => this.$refs.cld.updateCalendar(this.records, this.getSelectedCoworking()))
    },
    calendar_mobile_createEvent(date) {
      this.openModal('master_cabinet_calendar_new_record')
      this.setModalData(date)
    },
    loadRents() {
      return this.$api.master.rent.list({start_at: this.period.start, end_at: this.period.end}).then(({data}) => {
        this.setCoworking(this.records = data).forEach(val => this.setSelectedCoworking(true, val.id, true))
      })
    }
  },
  watch: {
    'api.currentData.dateProfile.renderRange.start'(to, from) {
      this.period = {
        start: moment(to).format('YYYY-MM-DD 00:00:01'),
        end: moment(this.api.currentData.dateProfile.renderRange.end).format('YYYY-MM-DD 23:59:59')
      }
      if (to !== from) this.loadRecords()
    }
  }
}
</script>

<style scoped lang="scss">
.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}

.tabs {
  margin-top: 0;
  margin-bottom: 30px;
}

.filter {
  display: flex;
  border-bottom: 1px solid #E5E5E5;
  margin: 0 -30px;
  padding: 0 30px 30px 30px;

  & .item {
    margin: 0 10px;

    &:first-child {
      margin-left: 0;
    }
  }
}

.mini-calendar {
  display: flex;
  border-bottom: 1px solid #E5E5E5;
  margin: 0 -30px;
  padding: 0;

}

@media (max-width: 600px) {
  .filter {
    flex-direction: column;

    & .item {
      margin: 10px 0 0 0;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}

button {
  background-color: unset;
  border: unset;
}

.calendar-control {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.calendar-title {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;

  & > span {
    font-weight: 500;
  }
}

.control-btn {
  color: #DBBFA7;
  margin-left: 19px;
  margin-right: 19px;
}

.today-btn {
  border: 1px solid #DBBFA7;
  border-radius: 5px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #DBBFA7;
  padding: 2px 15px;
}

@media screen and (max-width: 991px) {
  .whiteBg {
    margin: 0 -15px;
    padding-top: 0;
  }
}
</style>
